class FaqNav extends HTMLElement {
  connectedCallback() {
    this._categories = [...document.querySelectorAll('[data-faq-category]')];
    this._intersecting = new Map();

    this._buildTabs();
    this._tabs = [...this.querySelectorAll('[data-faq-tab]')];

    this.addEventListener('click', (e) => {
      const tab = e.target.closest('[data-faq-tab]');
      if (!tab) return;
      e.preventDefault();
      this._scrollToCategory(tab.dataset.faqTab);
    });

    if (this._categories.length) {
      this._setActiveTab(this._categories[0].dataset.faqCategory);
      this._observeCategories();
    }
  }

  _buildTabs() {
    const list = this.querySelector('[role="list"]');
    if (!list) return;

    this._categories.forEach((cat, i) => {
      const heading = cat.querySelector('.main-faq__category-heading');
      if (!heading) return;

      const id = cat.dataset.faqCategory;
      const a = document.createElement('a');
      a.className = 'main-faq__tab gant-body';
      a.href = `#faq-${id}`;
      a.dataset.faqTab = id;
      a.setAttribute('aria-current', i === 0 ? 'true' : 'false');
      a.textContent = heading.textContent.trim();

      const li = document.createElement('li');
      li.className = 'main-faq__tab-item';
      li.appendChild(a);
      list.appendChild(li);
    });
  }

  _scrollToCategory(id) {
    const cat = this._categories.find((c) => c.dataset.faqCategory === id);
    if (!cat) return;
    cat.scrollIntoView({ behavior: 'smooth', block: 'start' });
    this._setActiveTab(id);
  }

  _setActiveTab(id) {
    this._tabs.forEach((tab) => {
      const active = tab.dataset.faqTab === id;
      tab.setAttribute('aria-current', active ? 'true' : 'false');
    });

    const activeTab = this._tabs.find((t) => t.dataset.faqTab === id);
    if (activeTab && !window.matchMedia('(min-width: 1025px)').matches) {
      activeTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }
  }

  _observeCategories() {
    if (!('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        this._intersecting.set(entry.target.dataset.faqCategory, entry.isIntersecting);
      });
      const visible = this._categories.find((cat) => this._intersecting.get(cat.dataset.faqCategory));
      if (visible) this._setActiveTab(visible.dataset.faqCategory);
    }, { rootMargin: '-10% 0px -80% 0px', threshold: 0 });

    this._categories.forEach((cat) => observer.observe(cat));
    this._observer = observer;
  }

  // Called by FaqSearch when a search is cleared — restore all categories.
  restoreTabState() {
    this._categories.forEach((cat) => { cat.hidden = false; });
    if (this._categories.length) {
      this._setActiveTab(this._categories[0].dataset.faqCategory);
    }
  }

  disconnectedCallback() {
    if (this._observer) this._observer.disconnect();
  }
}

customElements.define('faq-nav', FaqNav);
